export const PATH = {
  HOME: '/home',
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    CHECK_AUTH: '/auth/check-auth',
    CHECK_TOKEN_RESET_PASSWORD: '/auth/check-code-reset-password',
    REGISTER: '/auth/register',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CHANGE_PASSWORD: '/auth/change-password',
  },
  ORDER: {
    ORDER_LIST: '/orders',
    IMPORT_ORDER: '/orders/import',
    ORDER_EDIT: '/orders/:id',
    CREATE_PRODUCT_TO_ORDER: '/orders/create-product-to-order',
    EXPORT_ORDER: '/orders/export/:id',
    IMPORT_PRODUCT: '/orders/import-product',
    RENDER_ORDER_NUMBER: '/orders/render-order-number',
    GET_INVENTORY_PRODUCT_START: '/inventory-starts',
    UPDATE_PRODUCT_ORDER: '/orders/product-order',
    ADD_PRODUCT_TO_ORDER: '/orders/add-product-to-order',
    CHANGE_INTERNAL_QUOTATION: '/orders/change-in-the-internal-quotation',
  },
  DASHBOARD: {
    HOME: '/dashboard',
  },
  ERROR: {
    NOT_FOUND: '/404',
  },
  SHIPPING: {
    SHIPPING_LIST: '/shippings',
    SHIPPING_DETAIL: '/shipping-detail',
  },
  PRODUCT: {
    PRODUCTS: '/products',
    PRODUCT_LIST: '/product/list',
    PRODUCT_LIST_NOT_LINK_ORDER: '/products/listProductNotLinkOrder',
    PRODUCT_LIST_LINK_ORDER: '/products/listProductLinkOrder',
    PRODUCT_SIZE_NITTO: '/product-size-nittos',
    IMPORT_PRODUCT: '/products/import',
    CREATE_IMPORT: '/products/create-import',
    UPDATE_IMPORT: '/products/update-import',
    PRODUCT_SIZE_CLASS: '/product-size-classes',
    CHECK_NITTOKU_CODE: '/products/checkNameNittokuCode',
    EXPORT_PRODUCT: '/products/exportCsv',
    IMPORT_ACTUAL_INVENTORY: '/products/import-inventory',
    UPDATE_PRODUCT_BY_IMPORT: '/products/update-product-info-by-import',
  },
  RECEIVING: {
    RECEIVING_LIST: '/acceptances',
    RECEIVING_IMPORT: '/acceptances/import',
  },
  MFG_REQUEST: {
    MFG_REQUEST_IMPORT: '/mfg-requests/import',
  },
  PRODUCTION_MANAGEMENT: {
    LIST: '/production-mgmts',
    IMPORT: '/production-mgmts/import',
    CREATE: '/production-mgmts',
    PRODUCT: '/production-mgmts/products',
    EXPORT_DAILY_SCHEDULE: '/production-mgmts/export-daily-schedule',
    EXPORT_MANUFACTURING_SHIPPING: '/production-mgmts/export-manufacturing-shipping',
    EXPORT_INVENTORY_FORM: '/production-mgmts/export-inventory-form',
    LATEST_IMPORT_FILE: '/production-mgmts/latest-imported-file',
    REVERT_IMPORT_FILE: '/production-mgmts/revert-imported-file',
    IMPORTED_FILES: '/production-mgmts/imported-files',
  },
  ROOT: '/',
  ROOT_DASHBOARD: '/dashboard',
  ROOT_AUTH: '/auth',
  ROOT_ERROR: '/error',
  ROOT_NOT_FOUND: '/404',
};
